import {container, title} from "assets/jss/material-kit-react.js";

const schedulePageStyle = theme => ({
  container: {
    zIndex: "12",
    color: "#00ffff",
    ...container
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#00ffff",
    textDecoration: "none"
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0",
    color: "#ff00ff"
  },
  main: {
    background: "#080808",
    position: "relative",
    zIndex: "3",
    minHeight: "100vh",
    padding: "0",
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  "@keyframes dropDown": {
    "0%": {bottom: "400px", opacity: 0.5},
    "50%": {bottom: "200px", opacity: 0.5},
    "100%": {bottom: "0px", opacity: 1},
  },
  animateDrop: {
    position: "relative",
    margin: "0 auto",
    "transform-origin": "10px 10px",
    animation: `$dropDown 1s ease-in forwards`,
    "animation-play-state": "running",
  },
  stepRoot: {
    width: '100%',
    '& .MuiStepLabel-label': {
      color: '#00ffff !important',
      fontFamily: '"Share Tech Mono", monospace',
      fontSize: '1.1rem',
      '&.MuiStepLabel-active': {
        color: '#ff00ff !important',
      },
      '&.MuiStepLabel-completed': {
        color: '#00ff00 !important',
      }
    },
    '& .MuiStepIcon-root': {
      color: '#ff00ff',
      '&.MuiStepIcon-active': {
        color: '#00ffff',
      },
      '&.MuiStepIcon-completed': {
        color: '#00ff00',
      }
    },
    '& .MuiStepContent-root': {
      borderLeft: '1px solid #ff00ff',
      marginLeft: '12px',
      paddingLeft: '20px',
    }
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    backgroundColor: '#ff00ff',
    color: '#000000',
    border: '1px solid #ff00ff',
    fontFamily: '"Share Tech Mono", monospace',
    '&:hover': {
      backgroundColor: 'rgba(255, 0, 255, 0.1)',
      color: '#ff00ff',
      boxShadow: '0 0 15px rgba(255, 0, 255, 0.3)',
    },
    '&:disabled': {
      backgroundColor: 'rgba(255, 0, 255, 0.3)',
      color: 'rgba(0, 0, 0, 0.5)',
    }
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    width: '25em',
    backgroundColor: 'rgba(12, 12, 12, 0.95)',
    color: '#00ffff',
    border: '1px solid #ff00ff',
    borderRadius: '4px',
  }
})

export default schedulePageStyle;
